import { render, staticRenderFns } from "./product-list-datalayer-event.vue?vue&type=template&id=5dd7af57"
import script from "./product-list-datalayer-event.vue?vue&type=script&lang=js"
export * from "./product-list-datalayer-event.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports